
import { Button } from "@/components/ui/button";
import { gameDebug } from "@/utils/debugUtils";

interface DebugPanelProps {
  gameId: string | null;
  currentRound: number;
  botIsThinking: boolean;
  botHasChosenWord: boolean;
  userHasSubmitted: boolean;
  isSubmitting: boolean;
  rounds: any[];
}

export const DebugPanel = ({
  gameId,
  currentRound,
  botIsThinking,
  botHasChosenWord,
  userHasSubmitted,
  isSubmitting,
  rounds
}: DebugPanelProps) => {
  const dumpGameState = () => {
    console.log("===== CURRENT GAME STATE =====");
    console.log("gameId:", gameId);
    console.log("rounds:", rounds);
    console.log("currentRound:", currentRound);
    console.log("botIsThinking:", botIsThinking);
    console.log("botHasChosenWord:", botHasChosenWord);
    console.log("userHasSubmitted:", userHasSubmitted);
    console.log("isSubmitting:", isSubmitting);
    console.log("==============================");
    
    gameDebug.dumpStateHistory();
  };

  return (
    <div className="mt-8 p-4 bg-gray-800 text-white rounded-lg">
      <h3 className="text-lg font-bold mb-2">Debug Panel</h3>
      <div className="grid grid-cols-2 gap-2 mb-4">
        <div><span className="font-semibold">Game ID:</span> {gameId}</div>
        <div><span className="font-semibold">Round:</span> {currentRound}</div>
        <div><span className="font-semibold">Bot thinking:</span> {botIsThinking ? "YES" : "NO"}</div>
        <div><span className="font-semibold">Bot has word:</span> {botHasChosenWord ? "YES" : "NO"}</div>
        <div><span className="font-semibold">User submitted:</span> {userHasSubmitted ? "YES" : "NO"}</div>
        <div><span className="font-semibold">Submitting:</span> {isSubmitting ? "YES" : "NO"}</div>
      </div>
      <div className="flex space-x-2">
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={dumpGameState}
        >
          Dump State
        </Button>
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={() => gameDebug.setDebugMode(true)}
        >
          Enable Debug
        </Button>
        <Button 
          variant="secondary" 
          size="sm" 
          onClick={() => console.clear()}
        >
          Clear Console
        </Button>
      </div>
      <div className="mt-2 text-xs text-gray-400">
        Press Ctrl+Shift+D to toggle this panel
      </div>
    </div>
  );
};
